import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';
import createUseBondScreenerViews, {
  type IUseBondScreenerViewsProps,
} from '@/creditflowresearch/application/BondScreener/Sidebar/createUseBondScreenerViews';
import { adaptFiltersToRequestFormat } from '../buildCorporateBondScreenerRequest';
import { useCorporateBondScreenerSidebarFilterContext } from './useCorporateBondScreenerSidebarFilterContext';
import useCorporateViewFiltersMapper from './useCorporateViewFiltersMapper';

const useBondScreenerViews = createUseBondScreenerViews<TFilterPayload>({
  useSidebarFilterContext: useCorporateBondScreenerSidebarFilterContext,
  useViewFiltersMapper: useCorporateViewFiltersMapper,
  adaptFiltersToRequestFormat,
});

export default useBondScreenerViews;
export type { IUseBondScreenerViewsProps };
